import getWindowsTimeZoneIdFromIANAId from './getWindowsTimeZoneIdFromIANAId';

export default function getOSTimeZoneId(): string {
    const OSIANATimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return getWindowsTimeZoneIdFromIANAId(OSIANATimeZone);
}
